export default __webpack_public_path__ + "media/circle-white-pattern.0f4f0674.png";